import { Component, TemplateRef, ViewChild } from "@angular/core";
import { UserInterface } from "@core/interfaces/user.interface";
import { MarketplaceListingsBasePageComponent } from "@features/equipment/pages/marketplace/listings-base/marketplace-listings-base-page.component";
import { MarketplaceListingInterface } from "@features/equipment/types/marketplace-listing.interface";

@Component({
  selector: "astrobin-marketplace-listings-page",
  templateUrl: "../listings-base/marketplace-listings-base-page.component.html",
  styleUrls: ["../listings-base/marketplace-listings-base-page.component.scss"]
})
export class MarketplaceListingsPageComponent extends MarketplaceListingsBasePageComponent {
  protected get menuComponentId(): string {
    return "main";
  }

  @ViewChild("titleTemplate", { static: false })
  titleTemplate: TemplateRef<any>;

  @ViewChild("descriptionTemplate", { static: false })
  descriptionTemplate: TemplateRef<any>;

  @ViewChild("navTemplate", { static: false })
  navTemplate: TemplateRef<any>;

  protected _getListingsFilterPredicate(
    currentUser: UserInterface | null
  ): (listing: MarketplaceListingInterface) => boolean {
    return listing => listing.lineItems.length > 0;
  }
}
